import React, { useState } from 'react';
import MonthlyChart from '../../components/monthly-chart';

const AllChargeStationMonthlyPayment = (): JSX.Element => {
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());

  function increment() {
    setCurrentYear(currentYear - 1);
  }

  function decrement() {
    setCurrentYear(currentYear + 1);
  }

  return (
    <>
      <MonthlyChart
        label="(Rs.) All charge stations total transactions"
        url={`/stats/charge-stations/monthly-total/year/${currentYear}`}
        currentYear={currentYear}
        type="Area"
        stroke="#48db4d"
        fill="#48db4d"
      >
        <h4 className="section-title">
          <button className="btn btn-light" onClick={increment}>
            <i className="fas fa-chevron-left"></i>
          </button>
          &nbsp;
          {currentYear}
          &nbsp;
          <button className="btn btn-light" onClick={decrement}>
            <i className="fas fa-chevron-right"></i>
          </button>
        </h4>
      </MonthlyChart>
    </>
  );
};

export default AllChargeStationMonthlyPayment;
